export default {
  namespaced: true,

  state: {
    data: {},
    meta: {},
    loading: false,
    error: null,
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setData(state, data) {
      state.data = data;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },
  },

  getters: {
    loading: state => state.loading,
    error: state => state.error,
    meta: state => state.meta,
  },
};
